// Fetch items
export const FETCH_REQUESTED = 'subscription/FETCH_REQUESTED';
export const FETCH_SUCCESS = 'subscription/FETCH_SUCCESS';
export const FETCH_FAILURE = 'subscription/FETCH_FAILURE';

// Modify subscription (braintree)
export const MODIFY_BRAINTREE_SUBSCRIPTION_REQUESTED = 'subscription/MODIFY_BRAINTREE_SUBSCRIPTION_REQUESTED';
export const MODIFY_BRAINTREE_SUBSCRIPTION_SUCCESS = 'subscription/MODIFY_BRAINTREE_SUBSCRIPTION_SUCCESS';
export const MODIFY_BRAINTREE_SUBSCRIPTION_FAILURE = 'subscription/MODIFY_BRAINTREE_SUBSCRIPTION_FAILURE';
